import { toast } from "sonner";
import { z } from "zod";

import { BaseForm, FormInput, FormTextarea } from "components/BaseForm";
import CampaignService from "services/Campaign";

const schema = z.object({
  name: z.string().min(1, "Name is required"),
  description: z.string().trim().min(1, "Description is required"),
});

const CampaignStatusForm = ({
  campaignStatus,
  onSuccess,
  submitButtonText = "Save",
}) => {
  const isEdit = !!campaignStatus?.id;

  const handleSubmit = async ({ name, description }) => {
    if (isEdit) {
      await CampaignService.editCampaignStatus(
        campaignStatus.id,
        name,
        description
      );
    } else {
      await CampaignService.createCampaignStatus(name, description);
    }
    toast.success(
      isEdit ? "Campaign status updated" : "Campaign status created"
    );
  };

  return (
    <BaseForm
      schema={schema}
      defaultValues={{
        name: campaignStatus?.name ?? "",
        description: campaignStatus?.description ?? "",
      }}
      onSubmit={handleSubmit}
      onSuccess={onSuccess}
      submitButtonText={submitButtonText}
    >
      <FormInput
        name="name"
        label="Name"
        placeholder="Campaign Status Name"
        required
      />
      <FormTextarea
        name="description"
        label="Description"
        placeholder="What this status means and when to use it"
        required
      />
    </BaseForm>
  );
};

export default CampaignStatusForm;
